/**
 * useRemoveHotspot — B8.1 BONUS
 *
 * useMutation gegen DELETE /api/v2/hotspots/:id.
 * Soft-delete: setzt UserHotspot auf active=false + sell_date=heute.
 *
 * WP11 (Deep-Review 04.09.): auch fuer den Unwatch-Flow verwendet
 * (HotspotsList.tsx WatchedRow) — eine reine watch-only-Zeile
 * (owned:false, watched:true) verschwindet dadurch tatsaechlich, statt nur
 * per PATCH watched:false auf inaktiv-aber-vorhanden gesetzt zu werden.
 * Entfernte/entwatchte Hotspots veralten auch Wallet- und
 * Dashboard-Aggregate, deshalb zusaetzlich zu ['hotspots']/['hotspot', id]
 * auch ['wallets'] und ['dashboard'] invalidieren.
 */
import { useMutation, useQueryClient } from '@tanstack/react-query'
import apiClient from '../../lib/api-client'

export function useRemoveHotspot() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (id: string | number) => {
      const result = await apiClient.DELETE('/api/v2/hotspots/{id}', {
        params: { path: { id: Number(id) } },
      })
      if (result.error) throw result.error
      return result.data
    },
    onSuccess: (_data, id) => {
      void queryClient.invalidateQueries({ queryKey: ['hotspots'] })
      void queryClient.invalidateQueries({ queryKey: ['hotspot', String(id)] })
      void queryClient.invalidateQueries({ queryKey: ['wallets'] })
      void queryClient.invalidateQueries({ queryKey: ['dashboard'] })
    },
  })
}
